import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function decimalValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const decimalRegex = /^\d+(\.\d{1,2})?$/;

    const valid = decimalRegex.test(String(control.value));
    return valid ? null : { invalidDecimal: { value: control.value } };
  };
}
